module.exports = __webpack_public_path__ + "static/media/playstore-1.2206beff.png";